import {SureFlowLoopDetail} from './sure-flow-loop-detail';

export class WorkingSureFlowLoop {

  id!: number;
  personId!: string;
  orgUnitId!: string;
  detail!: SureFlowLoopDetail;

}
